import { Link } from "react-router-dom";
import "./index.css";

export const AUTH_FIELD_SX = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "#f8fafc",
    "&.Mui-focused fieldset": {
      borderColor: "#305478",
      borderWidth: "2px",
    },
    "&.Mui-error fieldset": {
      borderColor: "#dc2626",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#305478",
  },
  "& .MuiInputLabel-root.Mui-error": {
    color: "#dc2626",
  },
  "& .MuiFormHelperText-root.Mui-error": {
    marginLeft: 0,
  },
};

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-page">
      <div className="auth-page__brand">
        <div className="auth-page__brand-content">
          <span className="landing-hero__badge">
            Конструктор интерактивных курсов
          </span>
          <Link to="/" className="auth-page__logo">
            InChat
          </Link>
          <p className="auth-page__tagline">
            Запишите уроки, соберите интерактивный сценарий — и ваша аудитория
            или команда начнёт проходить его в мессенджерах: Telegram и MAX
          </p>
        </div>
      </div>

      <div className="auth-page__form-area">
        <div className="auth-card">
          <div className="auth-card__header">
            <h1 className="auth-card__title">{title}</h1>
            {subtitle && <p className="auth-card__subtitle">{subtitle}</p>}
          </div>
          {children}
          {footer && <div className="auth-card__footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
